import { jsx as _jsx } from "react/jsx-runtime";
import { cdnClient, FilmFilterKey, getAttributeById } from '@vista/omnichannel-components-domain';
import { useOccContext } from '../../../context/occ/hooks/use-occ-context';
import { getFilterLabel } from '../../../utils/filters/get-filter-label';
import { Image } from '../../image/image';
export const useGroupOptions = (options, filterKey, attributeIconCdnOptions, allOptionLabel, attributeClassName) => {
    const { config, displayText, i18n } = useOccContext();
    return options.map(option => {
        var _a;
        const inputOption = {
            text: getFilterLabel(filterKey, option.value, config, displayText, i18n, allOptionLabel),
            value: option.value,
            children: []
        };
        if (filterKey === FilmFilterKey.Attribute) {
            const attribute = getAttributeById(option.value);
            if (attribute) {
                (_a = inputOption.children) === null || _a === void 0 ? void 0 : _a.push(_jsx(Image, { className: attributeClassName, alt: i18n.translatable(attribute.name), src: cdnClient.instance.attribute(attribute.id).icon(attributeIconCdnOptions) }, `attribute__${inputOption.value}`));
            }
        }
        return inputOption;
    });
};
